module.exports = __webpack_public_path__ + "loginbg2.6e268c36b1cfdea39d0b.jpg";


//////////////////
// WEBPACK FOOTER
// D:/Rohit's Project/Golfhubber/golfhubber_club_portal/src/assets/img/loginbg2.jpg
// module id = ../../../../../src/assets/img/loginbg2.jpg
// module chunks = styles